import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Particles.css';

const ParticlesBackground = () => {
  // Create a fixed array of particle data
  const particles = Array.from({ length: 40 }, (_, index) => {
    const size = Math.floor(Math.random() * 6) + 4; // Larger particles (4-10px)
    const hue = Math.floor(Math.random() * 360);
    
    return {
      id: index,
      size,
      color: `hsla(${hue}, 100%, 70%, 0.7)`, // More vibrant colors
      initialX: Math.floor(Math.random() * 80) + 10, // 10-90%
      initialY: Math.floor(Math.random() * 80) + 10, // 10-90%
      duration: Math.floor(Math.random() * 20) + 15 // 15-35 seconds
    };
  });

  return (
    <div className="particles-container">
      {particles.map(particle => (
        <motion.div
          key={particle.id}
          className="particle"
          style={{
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            backgroundColor: particle.color,
            left: `${particle.initialX}%`,
            top: `${particle.initialY}%`
          }}
          animate={{
            x: [-30, 30, -15, 15, -30],
            y: [30, -30, 15, -15, 30],
            scale: [1, 1.2, 1, 1.1, 1],
            opacity: [0.6, 0.9, 0.6, 0.8, 0.6]
          }}
          transition={{
            duration: particle.duration,
            repeat: Infinity,
            repeatType: "loop",
            ease: "easeInOut",
            times: [0, 0.25, 0.5, 0.75, 1]
          }}
        />
      ))}
    </div>
  );
};

export default ParticlesBackground; 